// 한국시간 날짜 도우미 — 새벽 배송(한국 0~9시)이 세계표준시로는 '어제'가 되어 오늘 숫자에서 빠지던 문제를 막는다
export function kstDay(d: Date = new Date()): string {
  return new Date(d.getTime() + 9 * 3600 * 1000).toISOString().slice(0, 10);
}
